@if (list.page$ | async; as page) {
  <!-- Already assigned entries -->
  @if (alreadyAssignedEntries.length > 0) {
    <ngb-alert [dismissible]="false" type="info">
      <div class="d-flex align-items-center" (click)="toggleAlreadyAssignedEntries()">
        <div class="flex-grow-1">
          <div class="mb-1">
            <strong>
              {{ messages?.alreadyAssigned ?? 'bulkActions.alreadyAssignedEntries' | portalTranslate }}
            </strong>
            <span class="badge text-bg-info ms-1">{{ alreadyAssignedEntries.length }}</span>
          </div>
          <div>
            {{
              messages?.alreadyAssignedDescription ?? 'bulkActions.alreadyAssignedEntries.description'
                | translate
            }}
          </div>
        </div>
        <i class="far fa-angle-down"></i>
      </div>
      <div [ngbCollapse]="hideAlreadyAssignedEntries">
        <div class="bulk-action__entries">
          @for (entry of alreadyAssignedEntries; track entry) {
            <div class="bulk-action__entry">
              <span class="content">
                <ng-template
                  [ngTemplateOutlet]="entryTemplate"
                  [ngTemplateOutletContext]="{ entry }"
                ></ng-template>
              </span>
            </div>
          }
        </div>
      </div>
    </ngb-alert>
  }
  <!-- Unavailable entries -->
  @if (unavailableEntries.length > 0) {
    <ngb-alert [dismissible]="false" type="info">
      <div class="d-flex align-items-center" (click)="toggleUnavailableEntries()">
        <div class="flex-grow-1">
          <div class="mb-1">
            <strong>{{ messages?.unavailable ?? 'bulkActions.hiddenEntries' | portalTranslate }}</strong>
            <span class="badge text-bg-info ms-1">{{ unavailableEntries.length }}</span>
          </div>
          <div>
            {{ messages?.unavailableDescription ?? 'bulkActions.hiddenEntries.description' | translate }}
          </div>
        </div>
        <i class="far fa-angle-down"></i>
      </div>
      <div [ngbCollapse]="hideUnavailableEntries">
        <div class="bulk-action__entries">
          @for (entry of unavailableEntries; track entry) {
            <div class="bulk-action__entry">
              <span class="content">
                <ng-template
                  [ngTemplateOutlet]="entryTemplate"
                  [ngTemplateOutletContext]="{ entry }"
                ></ng-template>
              </span>
            </div>
          }
        </div>
      </div>
    </ngb-alert>
  }
  <div class="bulk-action__header">
    <span>
      @if (showOnlyFailures) {
        <strong>{{ 'bulkActions.failedEntries' | portalTranslate }}</strong>
      }
      @if (showOnlyFailures === false) {
        <strong>{{ 'bulkActions.entries' | portalTranslate }}</strong>
      }
      <span class="badge text-bg-info ms-1">{{ page.filtered }}</span>
      <small>
        @if (showOnlyFailures) {
          <button class="btn btn-link" (click)="toggleFailures()" role="button">
            {{ 'bulkActions.showAll' | portalTranslate }}
          </button>
        }
      </small>
    </span>
    @if (entries.length > page.pageSize) {
      <portal-pagination
        [page]="page"
        [simpleWithInfo]="true"
        (onPageChanged)="updatePage($event)"
        buttonSize="sm"
      ></portal-pagination>
    }
  </div>
  @if (noEntryAvailable) {
    <div>
      {{ 'bulkActions.noEntriesAvailable' | portalTranslate }}
    </div>
  }
  <div class="bulk-action__entries">
    @for (entry of page.entries; track entry) {
      <div
        class="bulk-action__entry"
        [ngClass]="{
          'bulk-action__entry--error': entry.error != null,
          'bulk-action__entry--success': entry.success,
        }"
      >
        <span class="content">
          <ng-template
            [ngTemplateOutlet]="entryTemplate"
            [ngTemplateOutletContext]="{ entry: entry.value }"
          ></ng-template>
        </span>
        @if ((list.page$ | async)!.total > 1) {
          @if (pending === false && entry.processed === false) {
            <portal-icon-button (onClick)="removeEntry(entry)" iconClass="far fa-times"></portal-icon-button>
          } @else {
            @if (entry.processing) {
              <i class="far fa-circle-notch fa-spin bulk-action__icon"></i>
            }
            @if (entry.processing === false && entry.success) {
              <i class="far fa-check bulk-action__icon"></i>
            }
            @if (entry.processing === false && entry.success === false) {
              <i class="far fa-bolt bulk-action__icon"></i>
            }
          }
        } @else {
          @if (entry.processing) {
            <i class="far fa-circle-notch fa-spin bulk-action__icon"></i>
          }
          @if (entry.processing === false && entry.success) {
            <i class="far fa-check bulk-action__icon"></i>
          }
          @if (entry.processing === false && entry.success === false) {
            <i class="far fa-bolt bulk-action__icon"></i>
          }
        }
      </div>
    }
  </div>
  @if (pending || hasBeenProcessed) {
    <div class="mt-3">
      <strong>
        <span>{{ 'bulkActions.state' | portalTranslate }}</span>
      </strong>
    </div>
  }
  <!-- Progress -->
  @if (pending || hasBeenProcessed) {
    <div class="progress my-2">
      @if (processingSuccesses > 0) {
        <div class="progress-bar text-bg-success" [style]="progressSuccess">
          <span>{{ processingSuccesses }}</span>
        </div>
      }
      @if (processingFailures > 0) {
        <div
          class="progress-bar text-bg-danger g-cursor-pointer"
          [style]="progressFailure"
          (click)="toggleFailures()"
        >
          <span>{{ processingFailures }}</span>
        </div>
      }
    </div>
  }
}
